import { useEffect, useState } from 'react';
import './App.css';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Home from './components/HomePage/Home/Home';
import AllWork from './components/AllWork/AllWork';
import AllBlog from './components/AllBlog/AllBlog';
import About from './components/About/About';
import ContactMe from './components/ContactMe/ContactMe';
import gif from './images/u.gif';
import MessengerCustomerChat from 'react-messenger-customer-chat';


function App() {
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false)
    }, 1500);
    return () => clearTimeout(timer);
  }, []);
  const gifStyle = {
    width: "100vw",
    height: "100vh"
  }
  return (
    <>
      {
        isLoading ? <img style={gifStyle} src={gif} alt="" /> :
          <Router>
          <MessengerCustomerChat
              pageId="104057955200408"
              appId="488450645640715"
          />
            <Switch>
              <Route exact path="/">
                <Home />
              </Route>
              <Route path="/home">
                <Home />
              </Route>
              <Route path="/about">
                <About />
              </Route>
              <Route path="/contact">
                <ContactMe />
              </Route>
              <Route path="/work">
                <AllWork />
              </Route>
              <Route path="/blog">
                <AllBlog />
              </Route>
            </Switch>
          </Router>
      }
    </>
  );
}

export default App;
